import styled from 'styled-components';

export const ShipmentCarrierStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;

  img {
    max-width: 40px;
    border-radius: 4px;
    border: 1px solid #dfe3e8;
  }

  .default-carrier-img {
    max-width: 40px;
    border-radius: 4px;
    border: 1px solid #dfe3e8;
    display: flex;
    align-items: center;
    justify-content: center;

    .Polaris-Icon {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
`;
